<div class="container setup-pswd-wrapper">
  <div class="col-sm-12 text-center">
    <img class="title-img img-fluid" src="/assets/images/lock.png" />
    <p class="text-pink mt-3 bold-text">
      <b> Set up a password to create your account. </b>
    </p>
  </div>
  <div class="row>">
    <form
      class="form form-wrapper"
      (ngSubmit)="onSetupSubmit()"
      [formGroup]="setupPasswordForm"
      >
      <div class="col-lg-4 col-sm-7 mx-auto form-cont">
        <div class="col-lg-12 col-sm-12 text-left">
          <div class="form-group mt-4">
            <label class="control-label mb-2" for="email"
              >Email Address</label
              >
              <input
                class="form-control lower-case no-validation"
                id="setup-password-email-input"
                name="email"
                readonly=""
                type="text"
                name="email"
                formControlName="email"
                />
            </div>
            <div class="form-group">
              <label class="control-label mb-2" for="password"
                >Create Password*</label
                >
                <input
                  class="form-control"
                  id="setup-password-password-input"
                  name="password"
                  type="password"
                  formControlName="password"
                  />
                @if ((setupForm['password'].errors?.['required'] || setupForm['password'].errors?.['pattern'] || setupForm['password'].errors?.['minlength'] || setupForm['password'].errors?.['maxlength'])&&
                  (setupForm['password'].dirty || setupForm['password'].touched || setupFormSubmitted)) {
                  <p
                    class="error-msg"
                    id="setup-password-password-required-error-message"
                    >
                    Password must be between 8 and 50 characters long and include at least one letter and one number.
                  </p>
                }
              </div>
              <div class="form-group">
                <label class="control-label mb-2" for="confirm"
                  >Confirm Password*</label
                  >
                  <input
                    class="form-control"
                    id="setup-password-confirm-password-input"
                    name="confirm"
                    type="password"
                    formControlName="confirm_password"
                    />
                  @if ((setupForm['confirm_password'].errors?.['mustMatch'] )&&
                    (setupForm['confirm_password'].dirty || setupForm['confirm_password'].touched || setupFormSubmitted)) {
                    <p
                      class="error-msg"
                      id="setup-password-confirm-password-mustmatch-error-message"
                      >
                      Passwords do not match
                    </p>
                  }
                </div>
                <div class="text-center">
                  <div class="checkbox">
                    <label>
                      <input
                        id="setup-password-agree-checkbox"
                        name="agree"
                        type="checkbox"
                        formControlName="agree"
                        />
                      I agree to Play Octopus's
                      <button
                        type="button"
                        class="btn-agreement-link p-0 change-email-link"
                        id="setup-password-terms-btn"
                        (click)="showTermsModal('')"
                        >
                        Terms of Service</button
                        >*
                      </label>
                      @if ((setupForm['agree'].errors?.['required'] && !setupForm['confirm_password'].errors?.['mustMatch'] && !setupForm['confirm_password'].errors?.['required'] && setupFormSubmitted)) {
                        <p
                          class="error-msg agree-error"
                          id="setup-password-agree-required-error-message"
                          >
                          Please agree to proceed
                        </p>
                      }
                    </div>
                  </div>
                </div>
                <button
                  class="btn d-block mx-auto mt-3 btn-pink-filled btn-big submit-btn"
                  id="setup-password-submit-btn"
                  type="submit"
                  >
                  Next
                </button>
                <br />
                <div class="col-lg-12 col-sm-12 text-left">
                  <p class="text-left">
                    Already have an account?
                    <a class="text-pink" [routerLink]="['/login']" id="setup-password-signin-link">
                      Sign in
                    </a>
                  </p>
                </div>
              </div>
            </form>
          </div>
          <div class="row contact-footer">
            <div class="col-sm-12 col-lg-7 text-center mt-4 mx-auto mb-4">
              <p class="lite-text mt-4">
                If you have any questions or concerns, you may reach Octopus by
                visiting
                <a href="https://playoctopus.com/help" target="_blank" id="setup-password-help-link"
                  >playoctopus.com/help
                </a>
                or by calling (240) 366-5877 (Monday - Friday).
              </p>
            </div>
          </div>
        </div>
